import React, {useContext, useState, useEffect} from "react";
//import { ProfileContext } from "../ProfileContext";
import moment from "moment";

const Notification = ({profiledata, profileid}) =>{

    //const {profiledata} = useContext(ProfileContext);
    const [notificationlist, setNotificationList] = useState([]);
    
        useEffect(()=>{
            setNotificationList(profiledata?.notifications || []);
        }, []);

    if(!profiledata)
        return null;

    return(
    <div class="col-md-7">
        <div class="card shadow-sm p-3 profile-notify-height">
            <h6 class="mb-3">Notifications</h6>

            {notificationlist.length === 0 && (
                <div className="text-center text-muted py-3">
                    No record found
                </div>
            )}

            {notificationlist.length > 0 && notificationlist.map((notification, index)=>
                (
                    <div class="border-bottom py-2" key={index}>
                        <div class="d-flex justify-content-between">
                            <div>
                                <strong>Call to:</strong> {notification.name}  
                            </div>
                            <small class="text-muted">{ moment(notification.display_date).format('DD MMM YYYY') } {notification.display_time}</small>
                        </div>
                        <div class="text-secondary small">
                            Follow-up scheduled for tomorrow.
                        </div>
                    </div>
                ))
            }
        </div>
    </div>
    );

}

export default Notification;
